// Режим embed (iframe на чужой странице): сообщаем родителю высоту содержимого,
// чтобы он растянул iframe и внутри не было прокрутки.
//   postMessage('axis_size::{"height":1234}') — при любом изменении размера контента
// Родитель может запросить размер заново: postMessage('axis_size_request').
// Страница без embed (виджет-модалка, ERP) ничего не делает.

const isEmbed = () => {
    try {
        const embed = JSON.parse(sessionStorage.getItem('embed') || '{}');

        return !!embed && typeof embed === 'object' && 'footer' in embed;
    } catch (e) {
        return false;
    }
};

if (typeof window !== 'undefined' && window.parent !== window && isEmbed()) {
    const style = document.createElement('style');

    // высота документа = высота контента, без отступов под шапку и без внутренней прокрутки
    style.textContent = `
        html, body { height: auto !important; min-height: 0 !important; overflow: hidden !important; background: transparent !important; }
        #appCapsule { padding: 0 !important; margin: 0 !important; min-height: 0 !important; }
        #appCapsule .section { padding: 0 !important; }
        #appCapsule .sticky-top { position: static !important; }
    `;
    document.head.append(style);

    let last = 0;

    const send = () => {
        const height = Math.ceil(document.body.getBoundingClientRect().height);

        if (height > 0 && Math.abs(height - last) >= 2) {
            last = height;
            window.parent.postMessage('axis_size::' + JSON.stringify({height}), '*');
        }
    };

    const start = () => {
        new ResizeObserver(send).observe(document.body);
        send();
    };

    window.addEventListener('message', (e) => {
        if (e.data === 'axis_size_request') {
            last = 0;
            send();
        }
    });

    if (document.body) {
        start();
    } else {
        document.addEventListener('DOMContentLoaded', start);
    }
}
